<template>
  <tela-component :title="titleTela">
    <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
    <v-alert v-else-if="!clienteManut" type="info" text
      >Cliente não localizado</v-alert
    >
    <template v-else>
      <form-dados-cadastrais />
      <form-dados-residenciais class="mt-3" />
      <form-dados-contato class="mt-3" />
      <form-dados-adicionais class="mt-3" />
      <form-dados-referencia class="mt-3 mb-5" />
      <btn-salvar-cliente />
    </template>
  </tela-component>
</template>

<script>
import TelaComponent from "@/components/tela/TelaComponent.vue";
import { mapActions, mapMutations, mapState } from "vuex";
import FormDadosCadastrais from "@/components/clientes/FormDadosCadastrais.vue";
import FormDadosResidenciais from "@/components/clientes/FormDadosResidenciais.vue";
import FormDadosContato from "@/components/clientes/FormDadosContato.vue";
import FormDadosAdicionais from "@/components/clientes/FormDadosAdicionais.vue";
import FormDadosReferencia from "@/components/clientes/FormDadosReferencia.vue";
import BtnSalvarCliente from "@/components/clientes/BtnSalvarCliente.vue";

export default {  
  components: {
    TelaComponent,
    FormDadosCadastrais,
    FormDadosResidenciais,
    FormDadosContato,
    FormDadosAdicionais,
    FormDadosReferencia,
    BtnSalvarCliente,    
  },
  computed: mapState("clientes", ["clienteManut", "editar"]),
  data: () => ({
    loading: true,
    titleTela: "Dados do cliente",
  }),
  methods: {
    ...mapActions("clientes", ["getClientes"]),
    ...mapMutations("clientes", ["setClienteManut", "setEditar"]),
    isMobile() {
      return this.$mq == "sm";
    },
  },
  async mounted() {
    this.loading = true;
    this.setClienteManut(null);
    this.setEditar(false);
    try {
      const res = await this.getClientes({ pesquisa: this.$route.params.id });
      this.setClienteManut(res[0]);
      this.setEditar(this.clienteManut.matricula > 0);
    } catch (error) {
      this.$toasted.error(error);
    }
    this.loading = false;
  },
};
</script>

<style>
</style>